import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useRole } from '../../contexts/RoleContext';
import TeacherDashboard from './TeacherDashboard';
import CoordinatorDashboard from './CoordinatorDashboard';
import PrincipalDashboard from './PrincipalDashboard';
import MunicipalSecretaryDashboard from './MunicipalSecretaryDashboard';
import { Card } from '@themesberg/react-bootstrap';

const RoleBasedDashboard = () => {
  const { user, loading } = useAuth();
  const { selectedRole } = useRole();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Card border="light" className="shadow-sm">
        <Card.Body>
          <p className="text-center">Usuário não autenticado</p>
        </Card.Body>
      </Card>
    );
  }

  const getUserRole = () => {
    // Se há um papel selecionado no RoleContext, usar ele
    if (selectedRole) {
      return selectedRole;
    }

    // Fallback: buscar primeiro papel ativo
    if (user.municipality_users && user.municipality_users.length > 0) {
      const activeMunicipality = user.municipality_users.find(mu => mu.active);
      if (activeMunicipality) {
        return 'MUNICIPAL_SECRETARY';
      }
    }

    if (user.school_users && user.school_users.length > 0) {
      const activeSchoolUser = user.school_users.find(su => su.active);
      if (activeSchoolUser) {
        return activeSchoolUser.role;
      }
    }

    return null;
  };

  const role = getUserRole();

  const renderDashboard = () => {
    switch (role) {
      case 'TEACHER':
        return <TeacherDashboard user={user} />;
      case 'COORD':
        return <CoordinatorDashboard user={user} />;
      case 'PRINCIPAL':
        return <PrincipalDashboard user={user} />;
      case 'MUNICIPAL_SECRETARY':
        return <MunicipalSecretaryDashboard user={user} />;
      default:
        return (
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <div className="text-center py-5">
                <h4>Bem-vindo(a), {user.name}</h4>
                <p className="text-muted">
                  Nenhuma função encontrada. Entre em contato com o administrador.
                </p>
              </div>
            </Card.Body>
          </Card>
        );
    }
  };

  return renderDashboard();
};

export default RoleBasedDashboard;
